module.exports = __webpack_public_path__ + "static/media/cq_file_exel.dce2d492.svg";